import React from 'react';
const markers = ['USPTO EXPERTS', 'FEDERAL PROTECTION', 'AMAZON BRAND REGISTRY', 'LLC FORMATION', 'INTELLECTUAL PROPERTY', 'CEASE & DESIST', 'CASE MANAGERS', 'BRAND PROTECTION'];
const TrustedBySection = () => (
  <section className="py-5 bg-stone-100 border-y-2 border-stone-200 overflow-hidden">
    <div className="relative flex overflow-hidden">
      <div className="flex shrink-0 animate-[marquee_45s_linear_infinite] gap-20 items-center">
        {[...markers, ...markers].map((label, i) => (
          <span key={i} className="text-[11px] font-bold uppercase tracking-[0.25em] text-stone-400 whitespace-nowrap">{label}</span>
        ))}
      </div>
    </div>
  </section>
);
export default TrustedBySection;
